import React, { Component, useState, useRef, useEffect, useContext, useCallback } from 'react';

import { useTranslation } from 'react-i18next';
import '../99_untils/i18n';

import {
  useApiLoadingStatus, APILoadingStatus, APIProvider,
  Map, AdvancedMarker, Pin, ColorScheme, useMap
} from '@vis.gl/react-google-maps';

// Helper for Google Maps LatLngBounds
function getLatLngBounds(positions) {
  if (!window.google || !window.google.maps || positions.length === 0) return null;
  const bounds = new window.google.maps.LatLngBounds();
  positions.forEach(pos => bounds.extend(pos));
  return bounds;
}

import NavTaxiSelectContext from "./NavTaxiSelectContext";


import apiURLs from '../99_untils/apiURLs';

import './LiveMapping.css';

// import idolImgChaeyoung from '../images/idols/Chaeyoung_1_thumb.png';
// import idolImgDahyun from '../images/idols/Dahyun_1_thumb.png';
// import idolImgJeongyeon from '../images/idols/Jeongyeon_1_thumb.png';
// import idolImgJihyo from '../images/idols/Jihyo_1_thumb.png';
// import idolImgMina from '../images/idols/Mina_1_thumb.png';
// import idolImgMomo from '../images/idols/Momo_1_thumb.png';
// import idolImgNayeon from '../images/idols/Nayeon_1_thumb.png';
// import idolImgSana from '../images/idols/Sana_1_thumb.png';
// import idolImgTzuyu from '../images/idols/Tzuyu_1_thumb.png';
// import idolImgAllMembers from '../images/idols/Twice_Taxi_Map_Icon.png';

import exoTaxiIcon from '../Home/images/exo-taxi-map-icon.png';
// import idolImgBP from '../images/idols/blackpink_01_thumb.png';
// import idolImgJennie from '../images/idols/jennie_01.png';
// import idolImgJisoo from '../images/idols/jisoo_01.png';
// import idolImgLisa from '../images/idols/lisa_01.png';
// import idolImgRose from '../images/idols/rose_01.png';

export default function GoogleMapTracker() {
  // console.log("GoogleMapTracker constructor started ")
  const isMountedRef = useRef();
  const { i18n } = useTranslation();
  let curLang = i18n.language;

  const [position, setPosition] = useState({ lat: 22.3193, lng: 114.1 }); // Default to Hong Kong (Kenneth's center)
  const [mapCenter, setMapCenter] = useState({ lat: 22.3193, lng: 114.1 });

  const envCheck = process.env.NODE_ENV;

  const navTaxiSelectContext = useContext(NavTaxiSelectContext);
  // const [navTaxiSelected, setNavTaxiSelected] = useState(navTaxiSelectContext);
  const navTaxiSelectedRef = useRef('all');

  // console.log('GoogleMapTracker envCheck:', envCheck);
  // console.log('GoogleMapTracker apiURLs.getMapIDDev:', apiURLs.getMapIDDev);
  // console.log('GoogleMapTracker apiURLs.postTwiceGameVotingDataURL:', apiURLs.postTwiceGameVotingDataURL);



  const mapId = apiURLs.getMapID;
  const mapAPIKey = apiURLs.getMapAPIKey;

  // const mapId = apiURLs.getMapIDDev;
  // const mapAPIKey = apiURLs.getMapAPIKeyDev;

  // if (envCheck === 'production') {

  //   mapId = apiURLs.getMapIDProd;
  //   mapAPIKey = apiURLs.getMapAPIKeyProd;

  // }


  const [markersData, setMarkersData] = useState();

  const [dataLoaded, setDataLoaded] = useState();
  const [errorFound, setErrorFound] = useState();
  const [dataLoading, setDataLoading] = useState();

  const [map, setMap] = useState();
  const [isUserInteracting, setIsUserInteracting] = useState(false);
  const userInteractTimeout = useRef(null);

  // All taxis use the same EXO taxi image (marketing request)
  // idolIcons array removed — use exoTaxiIcon directly


  // const [taxiJennie, setTaxiJennie] = useState([]);
  // const [taxiJisoo, setTaxiJisoo] = useState([]);
  // const [taxiLisa, setTaxiLisa] = useState([]);
  // const [taxiRose, setTaxiRose] = useState([]);
  // const [taxiBP, setTaxiBP] = useState([]);

  const taxiJennie = useRef([]);
  const taxiJisoo = useRef([]);
  const taxiLisa = useRef([]);
  const taxiRose = useRef([]);
  const taxiBP = useRef([]);
  const taxiAll = useRef([]);


  // const [idolName, setIdolName] = useState(
  //   ['Chaeyoung', 'Dahyun', 'Jeongyeon',
  //     'Jihyo', 'Mina', 'Momo',
  //     'Nayeon', 'Sana', 'Tzuyu',
  //     'Twice']
  // );
  const [idolSelections, setIdolSelections] = useState(
    [ 'All', 'Jennie', 'Jisoo',
      'Lisa', 'Rosé','Blackpink']
  );
  const [idolName, setIdolName] = useState(
    [ 'group','jennie', 'jisoo',
      'lisa', 'rose']
  );
  const [idolNameZh, setIdolNameZh] = useState([
    '彩瑛', '多賢', '定延',
    '志效', 'Mina', 'Momo',
    '娜璉', 'Sana', '子瑜',
    'Twice'
  ]);

  // States for marker selection and camera following
  const [selectedMarkerId, setSelectedMarkerId] = useState(null);
  const [isFollowingMarker, setIsFollowingMarker] = useState(false);
  const [mapZoom, setMapZoom] = useState(10); // Default zoom level (Kenneth's request)
  const [pickedDeviceCenter, setPickedDeviceCenter] = useState(null);
  const [pickedDeviceZoom, setPickedDeviceZoom] = useState(null);

  let intervalIdFetchData = null;

  // Function to calculate the center point among all taxi locations
  const calculateMapCenter = (heartbeatsData) => {
    if (!heartbeatsData || Object.keys(heartbeatsData).length === 0) {
      return { lat: 22.3193, lng: 114.1694 }; // Default to Hong Kong
    }

    const locations = Object.values(heartbeatsData).map(device => ({
      lat: device.location._latitude,
      lng: device.location._longitude
    }));

    if (locations.length === 1) {
      return locations[0]; // If only one device, center on it
    }

    // Calculate average latitude and longitude
    const sumLat = locations.reduce((sum, loc) => sum + loc.lat, 0);
    const sumLng = locations.reduce((sum, loc) => sum + loc.lng, 0);

    const centerLat = sumLat / locations.length;
    const centerLng = sumLng / locations.length;

    return {
      lat: centerLat,
      lng: centerLng
    };
  };

  // Auto-fit map to all taxis when not following a marker
  useEffect(() => {
    if (!map || !dataLoaded || isFollowingMarker || isUserInteracting) return;
    const positions = Object.values(dataLoaded).map(device => ({
      lat: device.location._latitude,
      lng: device.location._longitude
    }));
    if (positions.length === 0) return;
    // Wait for Google Maps API to be available
    if (!window.google || !window.google.maps) return;
    const bounds = getLatLngBounds(positions);
    if (bounds) {
      map.fitBounds(bounds, { top: 80, bottom: 220, left: 80, right: 80 });
    }
  }, [map, dataLoaded, isFollowingMarker, isUserInteracting]);

  // On any user drag/zoom, exit follow mode and allow free map movement
  const handleUserInteraction = useCallback(() => {
    if (isFollowingMarker) {
      setIsFollowingMarker(false);
      // Do NOT clear selectedMarkerId here; keep the arrow on the selected taxi
    }
    setIsUserInteracting(true);
    if (userInteractTimeout.current) clearTimeout(userInteractTimeout.current);
    userInteractTimeout.current = setTimeout(() => {
      setIsUserInteracting(false);
    }, 2000);
  }, [isFollowingMarker]);

  // Function to calculate optimal zoom level based on device locations
  const calculateOptimalZoom = (heartbeatsData) => {
    if (!heartbeatsData || Object.keys(heartbeatsData).length === 0) {
      return 12; // Default zoom for Hong Kong
    }

    const locations = Object.values(heartbeatsData).map(device => ({
      lat: device.location._latitude,
      lng: device.location._longitude
    }));

    if (locations.length === 1) {
      return 16; // Close zoom for single device
    }

    // Calculate bounding box
    const lats = locations.map(loc => loc.lat);
    const lngs = locations.map(loc => loc.lng);

    const minLat = Math.min(...lats);
    const maxLat = Math.max(...lats);
    const minLng = Math.min(...lngs);
    const maxLng = Math.max(...lngs);

    // Calculate the span in degrees
    const latSpan = maxLat - minLat;
    const lngSpan = maxLng - minLng;
    const maxSpan = Math.max(latSpan, lngSpan);

    // Calculate zoom based on span (these values can be adjusted)
    let zoom;
    if (maxSpan > 0.1) {
      zoom = 10; // Very wide spread
    } else if (maxSpan > 0.05) {
      zoom = 12; // Wide spread
    } else if (maxSpan > 0.02) {
      zoom = 14; // Medium spread
    } else if (maxSpan > 0.01) {
      zoom = 15; // Close spread
    } else if (maxSpan > 0.005) {
      zoom = 16; // Very close spread
    } else {
      zoom = 17; // Extremely close spread
    }


    return zoom;
  };

  function MapPanner() {
    const map = useMap();


    useEffect(() => {
      if (map && pickedDeviceCenter && isFollowingMarker) {


        const getSelectedDeviceLocation = () => {
          if (!selectedMarkerId || !dataLoaded) return null;

          // Find matching device data by selectedMarkerId
          const deviceEntries = Object.entries(dataLoaded);
          const selectedEntry = deviceEntries.find(([deviceId, deviceData]) => deviceId === selectedMarkerId);

          if (selectedEntry) {
            const [deviceId, deviceData] = selectedEntry;
            return {
              lat: deviceData.location._latitude,
              lng: deviceData.location._longitude
            };
          }

          return null;
        };

        const selectedLocation = getSelectedDeviceLocation();
        if (selectedLocation) {
          map.panTo(selectedLocation);
        }

        map.setZoom(16);

        return () => {
          // clearInterval(panToLocInterval);
        }
      }
    }, [map, pickedDeviceCenter, isFollowingMarker]);

    return null; // This component doesn't render anything directly
  }

  // Function to handle marker click and start following
  const handleMarkerClick = (deviceId, deviceData) => {
    setSelectedMarkerId(deviceId);
    setIsFollowingMarker(true);
    const markerPosition = {
      lat: deviceData.location._latitude,
      lng: deviceData.location._longitude
    };
    setPickedDeviceCenter(markerPosition);
  };

  // Function to stop following and return to overview mode
  const stopFollowing = () => {
    setSelectedMarkerId(null);
    setIsFollowingMarker(false);
  };

  // Function to handle map clicks (to stop following and deselect any marker)
  const handleMapClick = () => {
    setSelectedMarkerId(null);
    setIsFollowingMarker(false);
  };

  // When language changes, stop following and reset to overview — same behaviour as tapping the map
  useEffect(() => {
    stopFollowing();
    if (dataLoaded) {
      const newCenter = calculateMapCenter(dataLoaded);
      const newZoom = calculateOptimalZoom(dataLoaded);
      setMapCenter(newCenter);
      setMapZoom(newZoom);
    }
    setIsUserInteracting(false);
  }, [i18n.language]);

  // When taxi filter changes, stop following and reset to overview
  useEffect(() => {
    stopFollowing();
    setIsUserInteracting(false);
  }, [navTaxiSelectContext.navTaxiSelected]);

  // useEffect(() => {
  //   // console.log('GoogleMapTracker navTaxiSelectedRef.current', navTaxiSelectedRef.current);
  //   // console.log('GoogleMapTracker navTaxiSelected', navTaxiSelected);
  //   // console.log('GoogleMapTracker navTaxiSelectContext', navTaxiSelectContext.navTaxiSelected);
  //   navTaxiSelectedRef.current = navTaxiSelectContext.navTaxiSelected;

  //   // navTaxiSelectContext
  //   // Cleanup function
  //   // return () => {
  //   //   isMountedRef.current = false;
  //   //   clearInterval(intervalIdFetchData);
  //   // };
  // }, [
  //   // navTaxiSelectedRef.current
  //   navTaxiSelectContext.navTaxiSelected
  // ]); // Empty dependency array - run once on mount


  useEffect(() => {
    isMountedRef.current = true;

    const fetchData = async () => {
      try {
        const response = await fetch(apiURLs.getLiveMapDataURL, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            ...(window.authTokenData ? { 'Authorization': `Bearer ${window.authTokenData}` } : {})
          }
        });
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const result = await response.json();
        setDataLoaded(result.heartbeats);

        // Only auto-center/zoom if not interacting and not following a marker
        if (isFollowingMarker && selectedMarkerId && result.heartbeats[selectedMarkerId]) {
          const followedDevice = result.heartbeats[selectedMarkerId];
          const followPosition = {
            lat: followedDevice.location._latitude,
            lng: followedDevice.location._longitude
          };
          setMapCenter(followPosition);
        } else if (!isUserInteracting) {
          const newCenter = calculateMapCenter(result.heartbeats);
          const newZoom = calculateOptimalZoom(result.heartbeats);
          setMapCenter(newCenter);
          setMapZoom(newZoom);
        }
        setErrorFound(null);
      } catch (error) {
        setErrorFound(error);
      } finally {
        setDataLoading(false);
      }
    };

    fetchData();
    intervalIdFetchData = setInterval(fetchData, 5000);

    return () => {
      isMountedRef.current = false;
      clearInterval(intervalIdFetchData);
    };
  }, [isFollowingMarker, selectedMarkerId, isUserInteracting]);



  return (
    <APIProvider apiKey={mapAPIKey}>
      {/* <NavTaxiSelectContext.Provider value={{navTaxiSelectedRef.current}}> */}
      <div style={{ height: '100vh', width: '100%', position: 'relative' }}>
        <Map
          mapId={mapId}
          defaultCenter={{ lat: 22.3193, lng: 114.1 }}
          defaultZoom={10}
          {...(isFollowingMarker ? { center: mapCenter, zoom: mapZoom } : {})}
          disableDefaultUI={true}
          colorScheme={ColorScheme.DARK}
          onClick={handleMapClick}
          onMapLoad={setMap}
          onDragstart={handleUserInteraction}
          onDragend={handleUserInteraction}
          onZoomChanged={handleUserInteraction}
          onIdle={handleUserInteraction}
        >
          {/* Create markers for each device in heartbeats */}
          {
            dataLoaded && Object.entries(dataLoaded).map(([deviceId, deviceData], index) => {
                  const isSelected = selectedMarkerId === deviceId;
                  let unknown_member = 'unknown_member';
                  if (deviceId.toLowerCase().includes(unknown_member.toLowerCase())) {
                    return null;
                  }

                  // Match deviceId with idolName (case-insensitive)
                  // let matchedIdolName = null;
                  let matchedIndex = 0;
                  // let momoIndex = null;
                  
                  // navTaxiSelectContext.navTaxiSelected == 'all' ? matchedIndex = 0 : null;
                  idolName.forEach((name, index) => {

                    if (deviceId.toLowerCase().includes('blackpink')) {
                      matchedIndex = 0;
                      console.log('dataLoaded && includes(blackpink)');
                    } else{
                      if (deviceId.toLowerCase().includes(name.toLowerCase())) {
                        matchedIndex = index;
                      } 
                    }
                    // if (deviceId.toLowerCase().includes(name.toLowerCase())) {
                    //   matchedIndex = index;
                    // } 
                  });


                  return (

                    <AdvancedMarker
                      key={deviceId}
                      position={{
                        lat: deviceData.location._latitude,
                        lng: deviceData.location._longitude
                      }}
                      style={
                        navTaxiSelectContext.navTaxiSelected == 'all' ? { display: 'block' }
                        : deviceId.toLowerCase().includes(navTaxiSelectContext.navTaxiSelected.toLowerCase()) ?
                        { display: 'block' } 
                        :
                        { display: 'none' }
                      }
                      onClick={() => handleMarkerClick(deviceId, deviceData)}
                    >
                      {/* Arrow indicator above name when selected */}
                      {isSelected &&
                        <div
                          style={{
                            width: '0px',
                            height: '0px',
                            borderLeft: '6px solid transparent',
                            borderRight: '6px solid transparent',
                            borderTop: '8px solid #fff8e7',
                            position: 'absolute',
                            top: '-45px',
                            left: '50%',
                            transform: 'translateX(-50%)',
                          }}
                        ></div>
                      }
                      <h6 style={{
                        position: 'absolute',
                        top: '-25px',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        color: isSelected ? '#fff8e7' : 'white',
                        padding: '2px 6px',
                        borderRadius: '4px',
                        fontSize: '16px',
                        whiteSpace: 'nowrap',
                        cursor: 'pointer',
                      }}>
                        {
                        idolName[matchedIndex].toLowerCase() == 'rose' 
                        // idolName[matchedIndex].toUpperCase().includes('rose')
                        ? 'ROSÉ' :
                        idolName[matchedIndex].toLowerCase() == 'blackpink' 
                        // idolName[matchedIndex].toUpperCase().includes('rose')
                        ? 'GROUP' :
                        idolName[matchedIndex].toUpperCase() 
                        }
                        {/* {navTaxiSelectContext.navTaxiSelected == 'all' ?
                          (curLang === 'en-HK' ? idolName[matchedIndex] : idolNameZh[matchedIndex])
                          :
                          (curLang === 'en-HK' ? idolName[matchedIndex] : idolNameZh[matchedIndex])
                        } */}
                      </h6>
                      {/* const [idolName, setIdolName] = useState(
                        [ 'All', 'Jennie', 'Jisoo',
                          'Lisa', 'Rosé','Blackpink']
                      ); 
                      const [idolIcons, setIdolIcons] = useState(
                        [
                          // idolImgAll,
                          idolImgJennie, idolImgJisoo, idolImgLisa,
                          idolImgRose, idolImgBP,
                        ]
                      );
                      */}
                      <img 
                        src={exoTaxiIcon} 
                        width={50} 
                        style={{ objectFit: 'contain', display: 'block' }} 
                        alt="Taxi Icon"
                      />
                    </AdvancedMarker>
                  );
              })
          }
        </Map>
        {/* Soft black gradient fade overlay for Figma-like effect */}
        <div className="live-mapping-gradient-fade" />
        <MapPanner />
        {/* Follow control button */}
        {/* {isFollowingMarker && (
          <div style={{
            position: 'absolute',
            top: '10px',
            right: '10px',
            background: 'rgba(0,255,0,0.9)',
            padding: '8px 12px',
            borderRadius: '6px',
            boxShadow: '0 2px 6px rgba(0,0,0,0.3)',
            zIndex: 1000
          }}>
            <div style={{
              fontSize: '12px',
              color: 'black',
              marginBottom: '4px',
              fontWeight: 'bold'
            }}>
              Following: {selectedMarkerId}
            </div>
            <button
              onClick={stopFollowing}
              style={{
                background: '#FF4444',
                color: 'white',
                border: 'none',
                padding: '4px 8px',
                borderRadius: '4px',
                fontSize: '12px',
                cursor: 'pointer'
              }}
            >
              Stop Following
            </button>
          </div>
        )} */}

        {/* Loading state */}
        {/* {!dataLoaded && (
          <div style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            background: 'rgba(255,255,255,0.9)',
            padding: '20px',
            borderRadius: '8px',
            boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
          }}>
            Loading taxi locations...
          </div>
        )} */}

        {/* Error state */}
        {errorFound && (
          <div style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            background: 'rgba(255, 255, 255, 0.7)',
            border: '1px solid red',
            padding: '20px',
            borderRadius: '8px',
            color: 'black'
          }}>
            {
              errorFound.message && 'Unable to load map data at the moment. Please try again later.'
            }
            {/* Error loading map data: {errorFound.message} */}
          </div>
        )}
      </div>
      {/* <div className=''> */}
      {/* Overlay removed as per request */}
      {/* </NavTaxiSelectContext.Provider> */}
    </APIProvider>
  );
}

